import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/gatsby';
import Axios from '../../utils/Axios';
import { getDocument, Resource } from '../../services/portal';
import { ReportTypes } from '../../enums';

interface FetchReportByTypePayload {
  loanerId: string;
  type: ReportTypes;
}

export const fetchReportByType = createAsyncThunk<
  any,
  FetchReportByTypePayload
>(
  'reports/fetchReportByType',
  async ({ loanerId, type }: FetchReportByTypePayload) => {
    try {
      if (type === ReportTypes.OverallPerformance) {
        const doc = await getDocument(
          `/loan-officers/${loanerId}/overall-performance/`,
        );
        const stats = (doc.data as Resource).attributes!;
        const metrics = (value: any) => ({
          ...value,
          '30_day_customers_referred': value.customers_referred_last_30_days,
        });
        return {
          loan_officer: metrics(stats.loan_officer_stats),
          company_average: metrics(stats.company_average),
          company_top_decile: metrics(stats.company_top_decile),
        };
      }
      const response = await Axios.get(
        `/deals/loan-officers/${loanerId}/graphs/${type}/`,
      );
      return response.data;
    } catch (error) {
      Sentry.captureException(error);
      const typedError: any = error;
      // get error status code
      const statusCode = typedError.response.status;
      if (statusCode === 500) {
        // display empty error message
        throw new Error('');
      }
      if (typeof typedError?.response?.data === 'string') {
        // set the message if its a string
        throw new Error(typedError.response.data);
      }

      throw new Error(''); // display empty error message
    }
  },
);
